import React, { useContext } from 'react';
import { EditorContext } from '@/features/editor/context/editor-context';
import { ChangelogEventTile } from '@/features/editor/widgets/changelog/event-tracking/event-tile';
import { TargetingDeviceType } from '@/webapi/use-experience-api';

export function ElementTrackingList() {
  const ctx = useContext(EditorContext);

  const elementTracking =
    ctx.experienceState?.currentExperience?.elementTracking?.map((e) => {
      if (typeof e.targetDevice === `undefined`) {
        return { ...e, targetDevice: TargetingDeviceType.ALL_DEVICES };
      }
      return e;
    });
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {elementTracking?.map((e) => (
        <ChangelogEventTile
          key={`tracking-tile-${e.ordinal}`}
          onClick={async () => {
            ctx?.inspectorNav?.gotoTrackElementEditor(e);
          }}
          ordinal={e.ordinal}
          elemTrack={e}
          device={ctx?.devicePreview?.editorState?.device}
        />
      ))}
    </>
  );
}
